import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//基础信息相关API

const adultEducation = {
    protocolArchiving: {
        save: config => createAPI('/adultEducation/protocolArchiving/save', 'post', config),
        queryList: config => createAPI('/adultEducation/protocolArchiving/queryList', 'post', config),
        saveRec: config => createAPI('/adultEducation/protocolArchiving/saveRec', 'post', config),
        queryRscList: config => createAPI('/adultEducation/protocolArchiving/queryRscList', 'post', config),
        deletefile: config => createAPI('/adultEducation/protocolArchiving/deletefile', 'post', config),
        del: config => createAPI('/adultEducation/protocolArchiving/del', 'post', config),
    }
};

export default adultEducation;



// WEBPACK FOOTER //
// ./src/api/modules/adultEducation.js